import history from "../history";
import $ from "jquery";
import Bowser from "bowser";
import moment from "moment";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
export const APP_VERSION = "2.1.0";
export const USE_BOWSER = true;

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const APP_URL = process.env.REACT_APP_APP_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN;


export const API_KEY = process.env.REACT_APP_API_KEY;
export const DOWNTIME_ACCESS_CODE = "wewillbeup";
export const IDLE_SESSION_TIMEOUT = 600000; // 600000 means default 10 minutes

export const SITEDOWN_DATA = {
  downtime_status: 1,
  server_down: 1,
  downtime_access_validity: "invalid",
  downtime_message: "<h3>A technical error has occurred</h3><p>Please try again in a few minutes. Thanks!</p>",
};

export const SET_STORAGE = (name, value) => {
  return localStorage.setItem(name, value);
};
export const GET_STORAGE = (name) => {
  return localStorage.getItem(name);
};
export const REMOVE_STORAGE = (name) => {
  return localStorage.removeItem(name);
};
export const ENCRYPT_SECRET_KEY = "123456";
export const USER = "plu";

let COOKIE_EXP_DAY_P = 5;
if (GET_STORAGE("settings")) {
  const settings = JSON.parse(GET_STORAGE("settings"));
  COOKIE_EXP_DAY_P = settings.cookie_exp_day ? parseInt(settings.cookie_exp_day) : 7;
}
export const COOKIE_EXP_DAY = COOKIE_EXP_DAY_P;

export function SET_COOKIE(cname, cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + COOKIE_EXP_DAY * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function SET_LOGIN_COOKIE(data) {
  let expireAfter = new Date();
  //setting up cookie expire date after 10 minutes
  expireAfter.setMinutes(expireAfter.getMinutes() + 10);
  //now setup cookie
  document.cookie =
    USER + "=" + data + "; domain=" + BASE_DOMAIN + "; expires=" + expireAfter.toUTCString() + "; path=/";
}

export function DELETE_LOGIN_COOKIE() {
  let expireAfter = new Date();
  const exdays = -1;
  //setting up cookie expire date after 10 minutes
  expireAfter.setTime(expireAfter.getTime() + exdays * 24 * 60 * 60 * 1000);
  //now setup cookie
  document.cookie = USER + "='data'; domain=" + BASE_DOMAIN + "; expires=" + expireAfter.toUTCString() + "; path=/";
}

export function GET_COOKIE(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function DELETE_COOKIE(cname) {
  var cvalue = "",
    exdays = -1;
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const ReadMore = (str, displayWord = 10) => {
  displayWord = parseInt(displayWord);
  let count = str.split(" ").length;
  if (count > displayWord) {
    let newTitle = "";
    let names = str.split(" ");
    for (let i = 0; i < displayWord; i++) {
      newTitle = newTitle + " " + names[i];
    }
    return newTitle + " ...";
  } else {
    return str;
  }
};

export const iniScheduleDateTime = (dateTime = null) => {
  let set_schedule_time = moment();
  if (dateTime != null) {
    set_schedule_time = dateTime;
  }
  let current_min = Math.floor(set_schedule_time.minutes() / 5);
  set_schedule_time.minutes(current_min >= 12 ? 5 : (current_min * 5) + 5);
  return set_schedule_time;
};

export const validScheduleTime = (selectedDate = moment(), selectedTime = moment()) => {

  // date is today, so only allow future times
  if (moment().isSame(selectedDate, 'day')) {
    let current_min = Math.floor(selectedTime.minutes() / 5);
    selectedTime.minutes(current_min >= 12 ? 5 : (current_min * 5) + 5);
    return {
      hours: {
        min: selectedTime.hours(),
        max: 24,
        step: 1,
      },
      minutes: {
        min: selectedTime.minutes(),
        max: 60,
        step: 5,
      },
    };
  }

  // date is in the future, so allow all times
  return {
    hours: {
      min: 0,
      max: 24,
      step: 1,
    },
    minutes: {
      min: 0,
      max: 60,
      step: 5,
    },
  };

};

export function AJAX_REQUEST(type = "GET", additional_url, data) {
  const c_user = JSON.parse(GET_STORAGE(USER));
  data.api_key = API_KEY;
  // data.site = SITE;
  if (c_user) {
    // data.user_token = c_user.token;
  } else {
    history.push("/login");
  }

  let rdata = "";

  if (c_user) {
    let promise = $.Deferred();
    $.ajax({
      type: type,
      url: API_URL + additional_url,
      data: data,
      headers: {
        Authorization: `Bearer ${c_user.token}`,
      },
      timeout: 60000,
      success: function (resp) {
        if (resp) {
          if (typeof resp === "object") {
            if (resp.hasOwnProperty("response")) {
              if (resp.response.hasOwnProperty("code")) {
                promise.resolve(resp);
              } else {
                const respo = {
                  response: {
                    code: 5000,
                    status: "success",
                    message: "Something went wrong. Please try again.",
                  },
                };
                promise.resolve(respo);
              }
            } else {
              const respo = {
                response: {
                  code: 5000,
                  status: "success",
                  message: "Something went wrong. Please try again.",
                },
              };
              promise.resolve(respo);
            }
          } else {
            const respo = {
              response: {
                code: 5000,
                status: "success",
                message: "Something went wrong. Please try again.",
              },
            };
            promise.resolve(respo);
          }
        } else {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Something went wrong. Please refresh the page again.",
            },
          };
          promise.resolve(respo);
        }
      },
      error: function (resp, textStatus) {
        if (textStatus === "timeout") {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Connection timeout. Please try again.",
            },
          };
          promise.resolve(respo);
        } else {
          if (resp.status === 500) {
            const respo = {
              response: {
                code: 5000,
                status: "success",
                message: "Something went wrong. Please try again.",
                originalMessage: resp.responseText,
              },
            };
            promise.resolve(respo);
          } else {
            sentryInitialErrorLog();
            SET_STORAGE("settings", JSON.stringify(SITEDOWN_DATA));
            history.push("/error");
          }
        }
      },
    });
    rdata = promise.promise();
  } else {
    let promise = $.Deferred();
    $.ajax({
      type: type,
      url: API_URL + additional_url,
      data: data,
      timeout: 60000,
      success: function (resp) {
        if (resp) {
          if (typeof resp === "object") {
            if (resp.hasOwnProperty("response")) {
              if (resp.response.hasOwnProperty("code")) {
                promise.resolve(resp);
              } else {
                const respo = {
                  response: {
                    code: 5000,
                    status: "success",
                    message: "Something went wrong. Please try again.",
                  },
                };
                promise.resolve(respo);
              }
            } else {
              const respo = {
                response: {
                  code: 5000,
                  status: "success",
                  message: "Something went wrong. Please try again.",
                },
              };
              promise.resolve(respo);
            }
          } else {
            const respo = {
              response: {
                code: 5000,
                status: "success",
                message: "Something went wrong. Please try again.",
              },
            };
            promise.resolve(respo);
          }
        } else {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Something went wrong. Please refresh the page again.",
            },
          };
          promise.resolve(respo);
        }
      },
      error: function (resp, textStatus) {
        if (textStatus === "timeout") {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Connection timeout. Please try again.",
            },
          };
          promise.resolve(respo);
        } else {
          if (resp.status === 500) {
            const respo = {
              response: {
                code: 5000,
                status: "success",
                message: "Something went wrong. Please try again.",
                originalMessage: resp.responseText,
              },
            };
            promise.resolve(respo);
          } else {
            sentryInitialErrorLog();
            SET_STORAGE("settings", JSON.stringify(SITEDOWN_DATA));
            history.push("/error");
          }
        }
      },
    });
    rdata = promise.promise();
  }

  rdata.then((results) => {
    const response = results.response;
    if (parseInt(response.code) === 4001 || parseInt(response.code) === 1001) {
      history.push("/login");
    }
  });
  return rdata;
}

export function AJAX_REQUEST_WITH_FILE(type = "GET", additional_url, data) {
  const c_user = JSON.parse(GET_STORAGE(USER));
  data.append("api_key", API_KEY);

  let promise = $.Deferred();
  if (c_user) {
    $.ajax({
      type: type,
      url: API_URL + additional_url,
      data: data,
      headers: {
        Authorization: `Bearer ${c_user.token}`,
      },
      dataType: "JSON",
      processData: false,
      contentType: false,
      timeout: 120000,
      success: function (resp) {
        if (resp) {
          if (typeof resp === "object") {
            if (resp.hasOwnProperty("response")) {
              if (resp.response.hasOwnProperty("code")) {
                promise.resolve(resp);
              } else {
                const respo = {
                  response: {
                    code: 5000,
                    status: "success",
                    message: "Something went wrong. Please try again.",
                  },
                };
                promise.resolve(respo);
              }
            } else {
              const respo = {
                response: {
                  code: 5000,
                  status: "success",
                  message: "Something went wrong. Please try again.",
                },
              };
              promise.resolve(respo);
            }
          } else {
            const respo = {
              response: {
                code: 5000,
                status: "success",
                message: "Something went wrong. Please try again.",
              },
            };
            promise.resolve(respo);
          }
        } else {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Something went wrong. Please refresh the page again.",
            },
          };
          promise.resolve(respo);
        }
      },
      error: function (resp, textStatus) {
        if (textStatus === "timeout") {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Connection timeout. Please try again.",
            },
          };
          promise.resolve(respo);
        } else {
          if (resp.status === 500) {
            const respo = {
              response: {
                code: 5000,
                status: "success",
                message: "Something went wrong. Please try again.",
                originalMessage: resp.responseText,
              },
            };
            promise.resolve(respo);
          } else {
            sentryInitialErrorLog();
            SET_STORAGE("settings", JSON.stringify(SITEDOWN_DATA));
            history.push("/error");
          }
        }
      },
    });
  } else {
    $.ajax({
      type: type,
      url: API_URL + additional_url,
      data: data,
      dataType: "JSON",
      processData: false,
      contentType: false,
      timeout: 120000,
      success: function (resp) {
        if (resp) {
          if (typeof resp === "object") {
            if (resp.hasOwnProperty("response")) {
              if (resp.response.hasOwnProperty("code")) {
                promise.resolve(resp);
              } else {
                const respo = {
                  response: {
                    code: 5000,
                    status: "success",
                    message: "Something went wrong. Please try again.",
                  },
                };
                promise.resolve(respo);
              }
            } else {
              const respo = {
                response: {
                  code: 5000,
                  status: "success",
                  message: "Something went wrong. Please try again.",
                },
              };
              promise.resolve(respo);
            }
          } else {
            const respo = {
              response: {
                code: 5000,
                status: "success",
                message: "Something went wrong. Please try again.",
              },
            };
            promise.resolve(respo);
          }
        } else {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Something went wrong. Please refresh the page again.",
            },
          };
          promise.resolve(respo);
        }
      },
      error: function (resp, textStatus) {
        if (textStatus === "timeout") {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Connection timeout. Please try again.",
            },
          };
          promise.resolve(respo);
        } else {
          if (resp.status === 500) {
            const respo = {
              response: {
                code: 5000,
                status: "success",
                message: "Something went wrong. Please try again.",
                originalMessage: resp.responseText,
              },
            };
            promise.resolve(respo);
          } else {
            sentryInitialErrorLog();
            SET_STORAGE("settings", JSON.stringify(SITEDOWN_DATA));
            history.push("/error");
          }
        }
      },
    });
  }

  return promise.promise();
}

export function AJAX_SERVICE_LOGIN_REQUEST(type = "GET", additional_url, data) {
  let new_data = new FormData();
  new_data.append("api_key", API_KEY);

  let promise = $.Deferred();
  $.ajax({
    type: type,
    url: API_URL + additional_url,
    data: new_data,
    headers: {
      Authorization: `Bearer ${data.user_token}`,
    },
    dataType: "JSON",
    processData: false,
    contentType: false,
    timeout: 60000,
    success: function (resp) {
      if (resp) {
        if (typeof resp === "object") {
          if (resp.hasOwnProperty("response")) {
            if (resp.response.hasOwnProperty("code")) {
              promise.resolve(resp);
            } else {
              const respo = {
                response: {
                  code: 5000,
                  status: "success",
                  message: "Something went wrong. Please try again.",
                },
              };
              promise.resolve(respo);
            }
          } else {
            const respo = {
              response: {
                code: 5000,
                status: "success",
                message: "Something went wrong. Please try again.",
              },
            };
            promise.resolve(respo);
          }
        } else {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Something went wrong. Please try again.",
            },
          };
          promise.resolve(respo);
        }
      } else {
        const respo = {
          response: {
            code: 5000,
            status: "success",
            message: "Something went wrong. Please refresh the page again.",
          },
        };
        promise.resolve(respo);
      }
    },
    error: function (resp, textStatus) {
      if (textStatus === "timeout") {
        const respo = {
          response: {
            code: 5000,
            status: "success",
            message: "Connection timeout. Please try again.",
          },
        };
        promise.resolve(respo);
      } else {
        if (resp.status === 500) {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Something went wrong. Please try again.",
              originalMessage: resp.responseText,
            },
          };
          promise.resolve(respo);
        } else {
          sentryInitialErrorLog();
          SET_STORAGE("settings", JSON.stringify(SITEDOWN_DATA));
          history.push("/error");
        }
      }
    },
  });

  return promise.promise();
}

export function AJAX_PUBLIC_REQUEST(type = "GET", additional_url, data) {
  data.api_key = API_KEY;

  let promise = $.Deferred();
  $.ajax({
    type: type,
    url: API_URL + additional_url,
    data: data,
    timeout: 60000,
    success: function (resp) {
      if (resp) {
        if (typeof resp === "object") {
          if (resp.hasOwnProperty("response")) {
            if (resp.response.hasOwnProperty("code")) {
              promise.resolve(resp);
            } else {
              const respo = {
                response: {
                  code: 5000,
                  status: "success",
                  message: "Something went wrong. Please try again.",
                },
              };
              promise.resolve(respo);
            }
          } else {
            const respo = {
              response: {
                code: 5000,
                status: "success",
                message: "Something went wrong. Please try again.",
              },
            };
            promise.resolve(respo);
          }
        } else {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Something went wrong. Please try again.",
            },
          };
          promise.resolve(respo);
        }
      } else {
        const respo = {
          response: {
            code: 5000,
            status: "success",
            message: "Something went wrong. Please refresh the page again.",
          },
        };
        promise.resolve(respo);
      }
    },
    error: function (resp, textStatus) {
      if (textStatus === "timeout") {
        const respo = {
          response: {
            code: 5000,
            status: "success",
            message: "Connection timeout. Please try again.",
          },
        };
        promise.resolve(respo);
      } else {
        if (resp.status === 500) {
          const respo = {
            response: {
              code: 5000,
              status: "success",
              message: "Something went wrong. Please try again.",
              originalMessage: resp.responseText,
            },
          };
          promise.resolve(respo);
        } else {
          sentryInitialErrorLog();
          if (USE_BOWSER) {
            const browser = Bowser.getParser(window.navigator.userAgent);
            if (browser.getBrowserName() === "Safari") {
              const curl = window.location.href;
              window.location.href = curl;
            } else {
              SET_STORAGE("settings", JSON.stringify(SITEDOWN_DATA));
              history.push("/error");
            }
          } else {
            SET_STORAGE("settings", JSON.stringify(SITEDOWN_DATA));
            history.push("/error");
          }
        }
      }
    },
  });
  return promise.promise();
}

export function is_Mac() {
  if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
    return 'mac';
  } else {
    return 'window';
  }
}

export function sentryConfig() {
  let errorTrackingStatus = 'disable'; //enable/disable
  let errorTrackingSentryDns = '';
  let settings = null;

  SET_COOKIE('sentryTrackingStatus', errorTrackingStatus);

  if (GET_STORAGE('settings')) {
    settings = JSON.parse(GET_STORAGE('settings'));
    if (settings) {
      errorTrackingStatus = settings.errorTrackingStatus ? settings.errorTrackingStatus : 'disable';
      errorTrackingSentryDns = settings.errorTrackingSentryDns ? settings.errorTrackingSentryDns : '';

      if (errorTrackingStatus === 'enable' && errorTrackingSentryDns !== '') {
        Sentry.init({
          dsn: errorTrackingSentryDns,
          integrations: [new Integrations.BrowserTracing()],
          tracesSampleRate: 1.0,
        });

        SET_COOKIE('sentryTrackingStatus', errorTrackingStatus);

        console.log('Sentry successfully configured.');
      }
    }
  }
}

export function sentryErrorLog(data = null) {
  if (GET_COOKIE('sentryTrackingStatus') === 'enable') {
    let responseCode = '';
    const successCodeList = [1000, 4000, 4004];
    if (data) {
      responseCode = data ? data.response ? data.response.code ? parseInt(data.response.code) : '' : '' : '';
      if (!successCodeList.includes(responseCode)) {
        Sentry.captureException(data);
        console.log('Sentry error logged:', responseCode);
      }
    }
  }
}


export function sentryInitialErrorLog() {
  Sentry.init({
    dsn: 'https://ca80b72712a448a2b38a72c48a353c92@o949555.ingest.sentry.io/5918160',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });

  const errorData = {
    response: {
      code: 5000,
      status: "error",
      message: "Server can't reach.",
    },
  };

  Sentry.captureException(errorData);

  console.log('Sentry inital error logged.');
}